module.exports = __webpack_public_path__ + "static/media/caret-right.b22d6984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/ScheduleCall/assets/caret-right.svg
// module id = 1710
// module chunks = 0